module.exports = __webpack_public_path__ + "static/media/61.7d06107a.jpg";